
/**
 * 주문 세션 생성 응답
 */
export type CreateOrderSession200 = {
  /** 응답 메시지 */
  message: string;
  /** 생성된 주문 ID */
  orderId?: string;
  /** 결제 페이지 URL */
  paymentUrl?: string;
  /** 성공 여부 */
  success: boolean;
};
